import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Paper from 'material-ui/Paper'

import { getTbuDashboard } from '../../actions/tbuDashboard'
import { getAgents } from '../../actions/search'
import Header from '../../components/Header/Header'

const cardStyle = {
  height: 200,
  width: 200,
  margin: 20,
  textAlign: 'center',
  display: 'inline-block',
  padding: 5
}

const mapStateToProps = state => ({
  userInfo: state.userInfo,
  agents: state.agents,
  tbuDashboard: state.tbuDashboard
})

const mapDispatchToProps = dispatch => {
  return {
    getTbuDashboard: bindActionCreators(getTbuDashboard, dispatch),
    getAgents: bindActionCreators(getAgents, dispatch),
    dispatch
  }
}

class TbuDashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tbuDashboard: props.tbuDashboard
    }
  }
  componentDidMount() {
    const { userInfo, tbuDashboard, getTbuDashboard, agents, getAgents } =
      this.props
    if (userInfo) {
      if (agents && Object.keys(agents).length !== 0) {
        getTbuDashboard(userInfo.id, agents)
      } else {
        getAgents()
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    const { userInfo, tbuDashboard, getTbuDashboard, agents } = this.props
    if (nextProps.tbuDashboard && nextProps.tbuDashboard !== tbuDashboard) {
      this.setState({
        tbuDashboard: nextProps.tbuDashboard
      })
    }
    if (nextProps.agents && nextProps.agents !== agents) {
      getTbuDashboard(userInfo.id, nextProps.agents)
    }
  }
  getTile(count, label) {
    return (
      <Paper style={cardStyle} zDepth={1} key={label}>
        <div className='itemNumber'>{count}</div>
        <div className='itemLabel'>{label}</div>
      </Paper>
    )
  }
  render() {
    const { tbuDashboard } = this.state
    return (
      <div>
        <Header {...this.props} title='Unified RCM Dashboard' />
        <div className='dashboard'>
          <center>
            <h4>TBU Dashboard</h4>
          </center>
          {tbuDashboard && tbuDashboard.length && (
            <div className='group'>
              {tbuDashboard.map((item, index) => {
                return !item.count ? (
                  this.getTile(item.count, item.label)
                ) : (
                  <a href={item.url} target='_blank' key={item.label}>
                    {this.getTile(item.count, item.label)}
                  </a>
                )
              })}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TbuDashboard)



/** WEBPACK FOOTER **
 ** ./src/containers/TbuDashboard/TbuDashboard.js
 **/